module.exports = __webpack_public_path__ + "img/b.f42c196f.png";